// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "\n.new-code{font-size:.75em;font-weight:normal;color:#666\n}\n.modal-bullet-list{list-style-type:disc;padding-left:20px;margin-left:20px\n}", "",{"version":3,"sources":["claim-log.vue"],"names":[],"mappings":";AAAA,UAAU,eAAA,CAAgB,kBAAA,CAAmB;AAE7C;AAFwD,mBAAmB,oBAAA,CAAqB,iBAAA,CAAkB;AAIlH","file":"claim-log.vue","sourcesContent":[".new-code{font-size:.75em;font-weight:normal;color:#666}.modal-bullet-list{list-style-type:disc;padding-left:20px;margin-left:20px}"]}]);
// Exports
module.exports = exports;
